<template>
  <div id="mydrag" ref="mydrag">
    <div id="dragIcon" ref="dragIcon"></div>
    <div id="myicon" ref="myicon">
      <a @click="puMan">{{ height > 60 ? "收起" : "展开" }}</a>
      <a @click="close">全屏</a>
    </div>

    <slot :mydata="height"></slot>
  </div>
</template>
<script>
export default {
  data() {
    return {
      height: 40,
      isFull: true,
    };
  },
  methods: {
    drag() {
      var oH = document.body.clientHeight;
      //var omydrag = document.getElementById("mydrag");
      var omydrag = this.$refs.mydrag;
      //var oDragIcon = document.getElementById("dragIcon");
      var oDragIcon = this.$refs.dragIcon;
      // 定义4个变量
      var disY = 0; //鼠标按下时光标的Y值

      var that = this;
      //3. 给小div加点击事件
      oDragIcon.onmousedown = function (ev) {
        var ev = ev || window.event;
        disY = ev.clientY; // 获取鼠标按下时光标Y的值
        document.onmousemove = function (ev) {
          var ev = ev || window.event;
          if (ev.clientY <= 50) {
            return;
          }
          var H = oH - ev.clientY;
          if (H < 50) {
            return;
          }
          omydrag.style.height = H + "px"; // 拖拽后物体的高
        };
        document.onmouseup = function () {
          document.onmousemove = null;
          document.onmouseup = null;
        };
      };
      oDragIcon.onmouseup = function () {
        that.height = that.$refs.mydrag.offsetHeight;
      };
    },
    puMan() {
      if (this.height > 60) {
        this.$refs.mydrag.style.height = 40 + "px";
        this.height = 40;
      } else {
        var oH = document.body.clientHeight;
        let height = oH > 650 ? 320 : 220;
        this.$refs.mydrag.style.height = height + "px";
        this.height = height;
      }
      this.isFull = !this.isFull;
    },
    close() {
      var oH = document.body.clientHeight;
      this.$refs.mydrag.style.height = oH - 50 + "px";
      this.height = oH - 50;
      this.isFull = false;
    },
  },
  mounted() {
    this.drag();
  },
};
</script>
<style>
#mydrag {
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: 222;
  width: 100%;
  height: 40px;
  background: #fff;
  overflow: hidden;
}
#dragIcon {
  width: 100%;
  height: 10px;
  background: #fff;
  cursor: row-resize;
  border-top: 1px #999 double;
}
#myicon {
  font-size: 18px;
  float: right;
  margin-right: 10px;
  cursor: pointer;
}
#myicon i:hover {
  color: red;
}
</style>


// WEBPACK FOOTER //
// src/components/locus/drag.vue